// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_AT_RULE_IMPORT_0___ = require("-!../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[6].rules[0].oneOf[1].use[0]!../../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[6].rules[0].oneOf[1].use[1]!../../../../node_modules/flag-icons/css/flag-icons.min.css");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/** Colors variables */
.sb-default .sb-wrapper {
  --sb-color: #fff;
  --sb-background: var(--button-color);
  --sb-border-radius: 4px;
  --sb-overflow: hidden;
}
.sb-default .sb-wrapper.sb-show-icon.sb-show-text {
  --sb-text-padding: 0 1em 0 0;
}
.sb-default .sb-wrapper.sb-show-icon.sb-show-text .sb-text {
  filter: none;
}

/** Colors variables */
.sb-circles-dark .sb-wrapper, .sb-circles-light .sb-wrapper {
  --sb-color: #fff;
  --sb-background: transparent;
  --sb-min-width: fit-content;
  --sb-height: fit-content;
  --sb-icon-size: 1.4em;
}
.sb-circles-dark .sb-wrapper:active .sb-icon, .sb-circles-light .sb-wrapper:active .sb-icon {
  box-shadow: 0 7px 8px -4px rgba(0, 0, 0, 0.2), 0 12px 17px 2px rgba(0, 0, 0, 0.14), 0 5px 22px 4px rgba(0, 0, 0, 0.12);
}
.sb-circles-dark .sb-wrapper .sb-icon, .sb-circles-light .sb-wrapper .sb-icon {
  background-color: var(--button-color);
  box-shadow: 0 3px 5px -1px rgba(0, 0, 0, 0.2), 0 6px 10px 0 rgba(0, 0, 0, 0.14), 0 1px 18px 0 rgba(0, 0, 0, 0.12);
  width: 2.5em;
  min-height: 2.5em;
  border-radius: 50%;
  transition: background 0.4s cubic-bezier(0.25, 0.8, 0.25, 1), box-shadow 280ms cubic-bezier(0.4, 0, 0.2, 1);
}
.sb-circles-dark .sb-wrapper .sb-text, .sb-circles-light .sb-wrapper .sb-text {
  color: var(--button-color);
  font-size: 0.8em;
  margin-top: 5px;
  border-radius: 1em;
  width: 100%;
  height: 1.8em;
  line-height: 1.8em;
  padding: 0;
  transition: background 0.4s cubic-bezier(0.25, 0.8, 0.25, 1), box-shadow 280ms cubic-bezier(0.4, 0, 0.2, 1);
}
.sb-circles-dark .sb-wrapper .sb-content, .sb-circles-light .sb-wrapper .sb-content {
  align-items: center;
  flex-direction: column;
}

.sb-circles-dark .sb-wrapper .sb-icon {
  background-color: var(--button-color);
}
.sb-circles-dark .sb-wrapper .sb-text {
  color: var(--button-color);
}

.sb-circles-light .sb-wrapper .sb-icon, .sb-circles-light .sb-wrapper .sb-text {
  color: var(--button-color);
}
.sb-circles-light .sb-wrapper .sb-icon {
  background: radial-gradient(ellipse farthest-corner at center, white 30%, #f2f2f2 100%);
}

/* You can add global styles to this file, and also import other style files */
body, html {
  height: 100vh;
  margin: 0;
}

body {
  font-family: Arial, sans-serif;
  height: 100vh;
  background-color: #fff; /* Background color for the top half */
  position: relative;
  display: block;
  justify-content: center;
  align-items: center;
}

body::after {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 50%;
  background: #fff;
  z-index: -1; /* Ensure the gradient is behind other content */
}

/* Old palette
\$theme-main: #B05995;
\$theme-contrast: #3792BF;
\$theme-1: #282B59;
\$theme-2: #D683DD;
\$theme-3: #27567A;
\$theme-4: #44DDC4;
\$theme-5: #3336AE;
\$theme-6: #18C43D;
*/
.material-symbols-outlined {
  cursor: pointer;
  font-variation-settings: "FILL" 0, "wght" 400, "GRAD" 0, "opsz" 48;
}

p {
  font-family: Arial, Helvetica, sans-serif;
  text-align: justify;
  color: #2D2D2A;
}

html, body {
  height: 100%;
}

body {
  margin: 0;
  font-family: Roboto, "Helvetica Neue", sans-serif;
}

.generic-button, .generic-button-alt {
  color: white;
  border-radius: 5px; /* Rounded corners */
  padding: 10px 20px; /* Padding for button size */
  margin-right: 10px;
  cursor: pointer; /* Pointer on hover */
  transition: background-color 0.3s; /* Smooth transition on hover */
}
.generic-button p, .generic-button-alt p {
  color: white;
  margin: 0;
}

.generic-button {
  background-color: #1B3E78; /* Button background color */
  border: 2px solid #1B3E78; /* No border */
}

.generic-button-alt {
  background-color: #0CAD99; /* Button background color */
  border: 2px solid #0CAD99; /* No border */
}

.generic-button:hover {
  background-color: #fff; /* Change color on hover */
  color: #1B3E78;
}
.generic-button:hover p {
  color: #1B3E78;
}

.generic-button-alt:hover {
  background-color: #fff; /* Change color on hover */
  color: #0CAD99;
}
.generic-button-alt:hover p {
  color: #0CAD99;
}

.generic-button:disabled, .generic-button-alt:disabled {
  background-color: #e7e7e7;
  border-color: #e7e7e7;
  cursor: not-allowed;
}

@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 900;
  src: url('DMSans-Black.488392488fc1755c.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 800;
  src: url('DMSans-ExtraBold.a5b0ab310755ef77.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 700;
  src: url('DMSans-Bold.5d8f19212e66f41c.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 600;
  src: url('DMSans-SemiBold.ba81386aaa3f8bec.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 500;
  src: url('DMSans-Medium.6e411356edf4bc5d.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 400;
  src: url('DMSans-Regular.254fafcf32e78d93.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 300;
  src: url('DMSans-Light.195d851006084602.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 200;
  src: url('DMSans-ExtraLight.a1df2f9a2054461d.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 100;
  src: url('DMSans-Thin.a9d11007dfa31cfb.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 900;
  src: url('DMSans-BlackItalic.6085069ea3ad7499.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 800;
  src: url('DMSans-ExtraBoldItalic.43c17c588c612b92.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 700;
  src: url('DMSans-BoldItalic.05455c47a70f72be.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 600;
  src: url('DMSans-SemiBoldItalic.7afda8ff11873b51.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 500;
  src: url('DMSans-MediumItalic.2f9b70a7382ac1bd.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 400;
  src: url('DMSans-Italic.da827be69095140a.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 300;
  src: url('DMSans-LightItalic.9ac218ec8d449389.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 200;
  src: url('DMSans-ExtraLightItalic.201c8891fc6a2a4e.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 100;
  src: url('DMSans-ThinItalic.65c007651b2972db.ttf');
}
/* Old palette
\$accent-btn: #DD7EB0;
\$dark-text: #303f71;
\$light-text: #fff;
\$inactive-text: #A3AED0;
\$accent-blue: #84D9FD;*/
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 900;
  src: url('DMSans-Black.488392488fc1755c.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 800;
  src: url('DMSans-ExtraBold.a5b0ab310755ef77.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 700;
  src: url('DMSans-Bold.5d8f19212e66f41c.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 600;
  src: url('DMSans-SemiBold.ba81386aaa3f8bec.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 500;
  src: url('DMSans-Medium.6e411356edf4bc5d.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 400;
  src: url('DMSans-Regular.254fafcf32e78d93.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 300;
  src: url('DMSans-Light.195d851006084602.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 200;
  src: url('DMSans-ExtraLight.a1df2f9a2054461d.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 100;
  src: url('DMSans-Thin.a9d11007dfa31cfb.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 900;
  src: url('DMSans-BlackItalic.6085069ea3ad7499.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 800;
  src: url('DMSans-ExtraBoldItalic.43c17c588c612b92.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 700;
  src: url('DMSans-BoldItalic.05455c47a70f72be.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 600;
  src: url('DMSans-SemiBoldItalic.7afda8ff11873b51.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 500;
  src: url('DMSans-MediumItalic.2f9b70a7382ac1bd.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 400;
  src: url('DMSans-Italic.da827be69095140a.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 300;
  src: url('DMSans-LightItalic.9ac218ec8d449389.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 200;
  src: url('DMSans-ExtraLightItalic.201c8891fc6a2a4e.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 100;
  src: url('DMSans-ThinItalic.65c007651b2972db.ttf');
}
/* Old palette
\$accent-btn: #DD7EB0;
\$dark-text: #303f71;
\$light-text: #fff;
\$inactive-text: #A3AED0;
\$accent-blue: #84D9FD;*/
.button-container {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 10px;
  margin-bottom: 10px;
  width: 100%;
}

.raised-footer {
  display: flex;
  justify-content: center;
  padding: 4px;
  background-color: #e1e3e4;
  border-top: 1px solid #ddd;
}

.disabled {
  background-color: #BDBDBD !important;
  cursor: not-allowed !important;
}

.view-toggle-btn {
  padding: 10px 20px;
  background-color: #0CAD99;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.view-toggle-btn:hover {
  background-color: white;
  color: #0CAD99;
}

.filter-button {
  margin-left: 10px;
  padding: 5px 10px;
  background-color: #0CAD99;
  border: 1px solid #0CAD99;
  color: white;
  border: none;
  border-radius: 25px;
  cursor: pointer;
}
.filter-button:hover {
  background-color: #fff;
  color: #0CAD99;
  border: 1px solid #0CAD99;
}

.spacer {
  flex-grow: 1;
  min-width: 10px;
}

.alphabet-filter {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  margin-bottom: 20px;
  font-family: Arial, sans-serif;
  font-size: 18px;
  border: 1px solid #caced1;
  border-radius: 5px;
  padding: 5px;
}

.letter-button {
  margin: 0 3px;
  padding: 0;
  border: none;
  background: none;
  color: #ccc; /* Muted color for non-active letters */
  cursor: pointer;
  transition: color 0.3s;
  font-weight: normal;
}

.letter-button:hover {
  color: #666; /* Slightly darker on hover */
}

.active-letter {
  color: #000; /* Black color for the active letter */
  font-weight: bold;
  text-decoration: underline; /* Optional: to make it stand out */
}

.search-note {
  color: #0CAD99;
  font-size: 9pt;
  font-weight: bold;
}

.centered-label {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.centered-label label {
  margin-bottom: 5px; /* Adds space between label and select */
  font-size: 10pt;
}

.note-container {
  text-align: center;
  margin-bottom: 20px;
}

.full-page-container {
  background-color: white;
  border-radius: 15px;
  padding: 20px;
  width: 72vw;
  margin: auto;
  margin-bottom: 10px;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  position: relative;
}

.loader-container {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.dots-container {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
}

.dot {
  height: 12px; /* Reduced size */
  width: 12px; /* Reduced size */
  margin-right: 6px; /* Adjusted spacing */
  border-radius: 6px; /* Matches smaller size */
  background-color: #1B3E78; /* Starts as pink */
  animation: pulse 1.5s infinite ease-in-out;
}

.dot:last-child {
  margin-right: 0;
}

.dot:nth-child(1) {
  animation-delay: -0.3s;
}

.dot:nth-child(2) {
  animation-delay: -0.1s;
}

.dot:nth-child(3) {
  animation-delay: 0.1s;
}

@keyframes pulse {
  0% {
    transform: scale(0.8);
    background-color: #1B3E78; /* Starts as pink */
    box-shadow: 0 0 0 0 rgba(27, 62, 120, 0.5); /* Subtle pink shadow */
  }
  50% {
    transform: scale(1.2);
    background-color: #0CAD99; /* Transitions to blue */
    box-shadow: 0 0 0 3px rgba(12, 173, 153, 0.2); /* Smaller blue shadow */
  }
  100% {
    transform: scale(0.8);
    background-color: #1B3E78; /* Returns to pink */
    box-shadow: 0 0 0 0 rgba(27, 62, 120, 0.5); /* Subtle pink shadow */
  }
}
/* Wrapper inside full-page-container for scrolling content */
.scrollable-content {
  width: 100%;
  max-height: calc(90vh - 40px);
  overflow-y: scroll;
  padding-right: 20px;
  box-sizing: border-box;
}

/* Custom scrollbar styles */
.scrollable-content::-webkit-scrollbar {
  width: 12px;
  display: none;
}

.scrollable-content::-webkit-scrollbar-track {
  background: transparent;
  border-radius: 15px;
}

.scrollable-content::-webkit-scrollbar-thumb {
  background-color: rgba(0, 0, 0, 0.2);
  border-radius: 15px;
  border: 3px solid white;
}

.scrollable-content::-webkit-scrollbar-thumb:hover {
  background-color: rgba(0, 0, 0, 0.4);
}

/* Wrapper */
.wrapper {
  width: 70vw;
  margin: auto auto 10vh auto;
  padding: 0;
  background: #fff;
  color: black;
}

.title-row ul,
.row ul {
  margin: 0;
  padding: 0;
  display: flex;
  justify-content: space-between;
}

.title-row ul li,
.row ul li {
  margin: 0;
  font-size: 16px;
  font-weight: normal;
  list-style: none;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20%;
  box-sizing: border-box;
  padding: 10px 10px; /* Reduced padding */
  text-align: center;
}
@media only screen and (max-width: 767px) and (min-width: 480px) {
  .title-row ul li,
  .row ul li {
    font-size: 13px;
  }
}
@media only screen and (max-width: 479px) {
  .title-row ul li,
  .row ul li {
    font-size: 13px;
  }
}

.title {
  padding: 20px 0 5px 0; /* Reduced padding */
  height: 40px; /* Adjusted height */
  font-size: 0;
  background-color: #3792BF;
  color: #fff;
  border-left: 1px solid white;
  align-items: center;
  justify-content: center;
}

.row ul {
  margin: 0;
  padding: 0;
  display: flex;
  justify-content: space-between;
}

.row ul li {
  margin: 0;
  font-size: 16px;
  font-weight: normal;
  list-style: none;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20%;
  box-sizing: border-box;
  padding: 10px 10px; /* Reduced padding */
  text-align: center;
}
@media only screen and (max-width: 767px) and (min-width: 480px) {
  .row ul li {
    font-size: 13px;
  }
}
@media only screen and (max-width: 479px) {
  .row ul li {
    font-size: 13px;
  }
}

.row {
  padding: 15px 0; /* Reduced padding */
  height: 30px;
  font-size: 0;
  position: relative;
  overflow: hidden;
  transition: all 0.2s ease-out;
  border-top: 1px solid #e7e7e7;
}

.row:hover {
  background-color: #0CAD99;
  color: #fff;
  height: 65px;
}
@media only screen and (max-width: 767px) {
  .row:hover {
    height: 85px;
  }
}
@media only screen and (max-width: 359px) {
  .row:hover {
    height: 105px;
  }
}

.row ul li {
  padding: 5px 10px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.row-filter {
  display: flex;
  justify-content: center; /* Adjust alignment as needed */
  align-items: center; /* Align items vertically */
}

.custom-select {
  flex: 1 1 150px; /* Allow the dropdowns to grow and shrink, with a minimum width */
  min-width: 150px; /* Set a minimum width to prevent them from getting too small */
  max-width: 200px;
}

.custom-select select {
  appearance: none;
  -webkit-appearance: none;
  width: 100%;
  font-size: 0.8rem; /* Adjust font size smaller */
  padding: 0.675em 1em 0.675em 1em; /* Adjust padding */
  background-color: #fff;
  border: 1px solid #caced1;
  border-radius: 0.25rem;
  color: #000;
  cursor: pointer;
  text-align: center; /* Center text */
}

.custom-select::before {
  border-left: var(--size) solid transparent;
  border-right: var(--size) solid transparent;
  border-bottom: var(--size) solid black;
  top: 55%;
}

.custom-select::after {
  border-left: var(--size) solid transparent;
  border-right: var(--size) solid transparent;
  border-top: var(--size) solid black;
  top: 75%;
}

.container-filter {
  margin-top: 20px; /* Adjust top margin as needed */
  justify-content: center;
  align-content: center;
}

.select-container {
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  flex-wrap: nowrap;
  padding: 5px;
  gap: 10px;
  flex-direction: row;
  gap: 10px;
  flex-grow: 0;
}

.dropdown-btn {
  padding: 3px 20px;
  background-color: #3792BF;
  color: white;
  border: none;
  cursor: pointer;
  border-radius: 25px;
  margin-bottom: 20px;
  display: block;
  width: 100%;
  text-align: center;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.filter-icons {
  display: flex;
  align-items: center;
  justify-content: center;
  align-items: center;
}

.dropdown-container {
  display: none;
  width: 68.5vw;
  padding: 10px;
  background-color: white;
}

.dropdown-container.show {
  display: block;
}

.radio-inputs {
  align-items: center;
  position: relative;
  display: flex;
  flex-wrap: wrap;
  border-radius: 0.5rem;
  background-color: #e1e3e4;
  box-sizing: border-box;
  box-shadow: 0 0 0px 1px rgba(0, 0, 0, 0.06);
  padding: 0.25rem;
  font-size: 14px;
  margin: 0 auto; /* Center the container horizontally */
  justify-content: center; /* Center the radio buttons */
}

.radio-inputs .radio {
  flex: 1 1 auto;
  text-align: center;
}

.radio-inputs .radio input {
  display: none;
}

.radio-inputs .radio .name {
  display: flex;
  cursor: pointer;
  align-items: center;
  justify-content: center;
  border-radius: 0.5rem;
  border: none;
  padding: 0.5rem 0;
  color: rgb(51, 65, 85);
  transition: all 0.15s ease-in-out;
}

.radio-inputs .radio input:checked + .name {
  background-color: #fff;
  font-weight: 600;
}

.main-container {
  display: flex;
  flex-direction: column;
  gap: 20px; /* Space between containers */
}

.raised-container {
  background-color: white;
  border-radius: 15px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  overflow: hidden;
}

.raised-header {
  background-color: #1B3E78;
  color: #fff;
  border-radius: 15px;
  padding: 10px 20px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  margin-bottom: 10px;
  display: flex;
  align-items: center;
  height: 60px; /* Ensure the same height for all headers */
}

.raised-header h2 {
  margin: 0;
  font-size: 1.5rem;
}

.row-wrapper {
  margin: 0 20px 15px 20px;
}

.no-results {
  margin: 30px;
}

.no-scroll-results {
  color: red;
  font-size: px;
  margin: 100px;
}

.reset-button {
  background-color: #ccc; /* Grey background for Reset button */
  color: #000; /* Black text color */
  border: 1px solid #ccc; /* Grey border */
}

.reset-button:hover {
  background-color: #bbb; /* Darker grey on hover */
  color: #000; /* Keep text color black on hover */
}

.select-container .custom-select {
  position: relative;
  font-family: Arial, sans-serif;
}
.select-container .custom-select .centered-label {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.select-container .custom-select .centered-label label {
  font-size: 14px;
  color: #333;
  margin-bottom: 4px;
}
.select-container .custom-select .checkbox-dropdown {
  height: 35px;
  position: relative;
}
.select-container .custom-select .checkbox-dropdown .dropdown-btn {
  background-color: #f0f0f5;
  border: 1px solid #ccc;
  border-radius: 8px;
  padding: 8px 13px;
  cursor: pointer;
  font-size: 14px;
  color: #333;
  min-width: 170px;
  max-width: 200px;
  width: 10vw; /* Ensure button takes full width of container */
  text-align: left;
  display: flex;
  justify-content: space-between;
  align-items: center;
  z-index: 1000;
}
.select-container .custom-select .checkbox-dropdown .dropdown-btn .arrow {
  font-size: 12px;
  color: #666;
  transition: transform 0.3s ease;
}
.select-container .custom-select .checkbox-dropdown .dropdown-btn:hover {
  background-color: #e0e0e5;
}
.select-container .custom-select .checkbox-dropdown .checkbox-list {
  position: absolute;
  top: 100%;
  left: 0;
  width: 80%; /* Set width to 100% to match dropdown button */
  max-height: 200px;
  overflow-y: auto;
  background-color: #fff;
  border: 1px solid #ccc;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  z-index: 1000;
  padding: 10px;
  margin-top: 4px;
  left: 50%; /* Start positioning from the horizontal center */
  transform: translateX(-50%); /* Shift back by 50% of the element's width to center */
  scrollbar-width: thin;
}
.select-container .custom-select .checkbox-dropdown .checkbox-list .checkbox-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  padding: 4px 0;
}
.select-container .custom-select .checkbox-dropdown .checkbox-list .checkbox-item input[type=checkbox] {
  margin-left: 8px;
}
.select-container .custom-select .checkbox-dropdown .checkbox-list .checkbox-item:hover {
  background-color: #f5f5f5;
}

.selected-chips {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 8px;
  margin-bottom: 0px;
  justify-content: center;
}
.selected-chips .chip {
  display: flex;
  align-items: center;
  background-color: #f0f0f5;
  border: 1px solid #ccc;
  border-radius: 16px;
  padding: 4px 8px;
  font-size: 14px;
  color: #333;
}
.selected-chips .chip .remove-chip {
  margin-left: 8px;
  cursor: pointer;
  font-size: 14px;
  color: #666;
}
.selected-chips .chip .remove-chip:hover {
  color: #333;
}

.card-arrow {
  display: flex;
  align-items: center; /* Center the chevron vertically */
  margin-left: auto; /* Push the arrow to the right */
  margin-right: 10px;
}
.card-arrow mat-icon {
  font-size: 24px;
  color: #2D2D2A;
  transition: color 0.3s ease;
}

.material-symbols-outlined:hover {
  color: #0CAD99;
}

@media (max-width: 1350px) {
  .selected-chips {
    width: 13vw;
  }
}
@media (max-width: 1150px) {
  .select-container {
    gap: 10px;
  }
  .select-container .custom-select {
    flex: 1 1 170px; /* Adjust the flex-basis to make it smaller */
    min-width: 170px; /* Set a smaller minimum width */
    max-width: 170px; /* Set a smaller maximum width */
  }
  .select-container .custom-select .checkbox-dropdown .dropdown-btn {
    font-size: 14px !important; /* Make the button text smaller */
    width: 17vw;
    min-width: 70px;
    max-width: 170px;
  }
  .select-container .custom-select .checkbox-dropdown .checkbox-list {
    position: absolute;
    top: 130%;
    width: 86%; /* Set width to 100% to match dropdown button */
  }
  .select-container .custom-select .checkbox-dropdown .checkbox-list .checkbox-item input[type=checkbox] {
    margin-left: 8px;
  }
  .select-container .custom-select .checkbox-dropdown .checkbox-list .checkbox-item:hover {
    background-color: #f5f5f5;
  }
  .selected-chips {
    width: 10vw;
  }
}
/* Three-wide Layout for Larger Screens */
@media (max-width: 1000px) {
  .row-filter {
    margin-bottom: 0px;
    margin-right: 10px;
    min-width: 70vw;
  }
  .button-container {
    min-width: 69vw;
    margin-right: 18px;
  }
  .filter-button {
    margin-left: 0px;
    margin-right: 18px;
  }
  .dropdown-container {
    justify-content: center;
    width: 65vw;
    margin-right: 18px;
  }
  .select-container {
    display: block;
    margin: 0;
    margin-right: 18px;
  }
  .custom-select {
    flex: 1; /* Allow flexibility */
    min-width: 60vw;
    max-width: 60vw; /* Three-wide layout with gap adjustment */
    margin-bottom: 10px;
  }
  .select-container {
    gap: 10px;
  }
  .select-container .custom-select {
    flex: 1 1 110px; /* Adjust the flex-basis to make it smaller */
    min-width: 110px; /* Set a smaller minimum width */
    max-width: 110px; /* Set a smaller maximum width */
  }
  .select-container .custom-select .checkbox-dropdown .dropdown-btn {
    font-size: 14px !important; /* Make the button text smaller */
    width: 60vw;
    min-width: 70px;
    max-width: 570px;
    margin: 10px;
  }
  .select-container .custom-select .checkbox-dropdown .checkbox-list {
    width: 90%;
  }
  .select-container .custom-select .checkbox-dropdown .checkbox-item {
    font-size: 14px !important;
  }
  .selected-chips {
    width: 60vw;
    padding: 10px;
  }
  .raised-header {
    justify-content: center;
    height: 30px; /* Ensure the same height for all headers */
  }
}`, "",{"version":3,"sources":["webpack://./node_modules/ngx-sharebuttons/themes/variables.scss","webpack://./node_modules/ngx-sharebuttons/themes/default.scss","webpack://./src/app/explore/explorer/explorer.component.scss","webpack://./node_modules/ngx-sharebuttons/themes/circles.scss","webpack://./src/styles.scss","webpack://./src/theme/fonts.scss","webpack://./src/theme/variables.scss"],"names":[],"mappings":"AAAA,sBAAA;ACEA;EACE,gBAAA;EACA,oCAAA;EACA,uBAAA;EACA,qBAAA;ACCF;ADCE;EACE,4BAAA;ACCJ;ADCI;EACE,YAAA;ACCN;;AFbA,sBAAA;AGME;EACE,gBAAA;EACA,4BAAA;EACA,2BAAA;EACA,wBAAA;EACA,qBAAA;ADWJ;ACRM;EACE,sHAAA;ADUR;ACNI;EACE,qCAAA;EACA,iHAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,2GAAA;ADQN;ACLI;EACE,0BAAA;EACA,gBA3BS;EA4BT,eAAA;EACA,kBAAA;EACA,WAAA;EACA,aAAA;EACA,kBAAA;EACA,UAAA;EACA,2GAAA;ADON;ACJI;EACE,mBAAA;EACA,sBAAA;ADMN;;ACCE;EACE,qCAAA;ADEJ;ACCE;EACE,0BAAA;ADCJ;;ACKE;EACE,0BAAA;ADFJ;ACKE;EACE,uFAAA;ADHJ;;AE1DA,8EAAA;AAEA;EACA,aAAA;EAEA,SAAA;AF2DA;;AExDA;EACI,8BAAA;EACA,aAAA;EACA,sBAAA,EAAA,sCAAA;EACA,kBAAA;EACA,cAAA;EACA,uBAAA;EACA,mBAAA;AF2DJ;;AEvDA;EACI,WAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,WAAA;EACA,gBAAA;EAGA,WAAA,EAAA,gDAAA;AFwDJ;;AEnDA;;;;;;;;;CAAA;AA0CA;EAEI,eAAA;EACA,kEACI;AFoBR;;AEdA;EACI,yCAAA;EACA,mBAAA;EACA,cAxDS;AFyEb;;AEZA;EAAa,YAAA;AFgBb;;AEfA;EAAO,SAAA;EAAW,iDAAA;AFoBlB;;AEjBA;EACE,YAAA;EACA,kBAAA,EAAA,oBAAA;EACE,kBAAA,EAAA,4BAAA;EACA,kBAAA;EAGA,eAAA,EAAA,qBAAA;EACA,iCAAA,EAAA,+BAAA;AFkBJ;AEhBI;EACI,YAAA;EACA,SAAA;AFkBR;;AEfA;EACE,yBArEW,EAqEoB,4BAAA;EAC/B,yBAAA,EAAA,cAAA;AFkBF;;AEfA;EACE,yBA7Da,EA6DoB,4BAAA;EACjC,yBAAA,EAAA,cAAA;AFkBF;;AEfA;EACI,sBAAA,EAAA,0BAAA;EACA,cAhFS;AFkGb;AEhBI;EACI,cAnFK;AFqGb;;AEdA;EACE,sBAAA,EAAA,0BAAA;EACA,cA5Ea;AF6Ff;AEfE;EACE,cA/EW;AFgGf;;AEbA;EACI,yBA/Ec;EAgFd,qBAhFc;EAiFd,mBAAA;AFgBJ;;AGpKA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,6CAAA;AHuKF;AGpKA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iDAAA;AHsKF;AGnKA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,4CAAA;AHqKF;AGlKA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,gDAAA;AHoKF;AGjKA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,8CAAA;AHmKF;AGhKA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,+CAAA;AHkKF;AG/JA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,6CAAA;AHiKF;AG9JA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kDAAA;AHgKF;AG7JA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,4CAAA;AH+JF;AG5JA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mDAAA;AH8JF;AG3JA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,uDAAA;AH6JF;AG1JA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kDAAA;AH4JF;AGzJA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,sDAAA;AH2JF;AGxJA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,oDAAA;AH0JF;AGvJA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,8CAAA;AHyJF;AGtJA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mDAAA;AHwJF;AGrJA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,wDAAA;AHuJF;AGpJA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kDAAA;AHsJF;AI1QA;;;;;uBAAA;ADPA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,6CAAA;AHyRF;AGtRA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iDAAA;AHwRF;AGrRA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,4CAAA;AHuRF;AGpRA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,gDAAA;AHsRF;AGnRA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,8CAAA;AHqRF;AGlRA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,+CAAA;AHoRF;AGjRA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,6CAAA;AHmRF;AGhRA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kDAAA;AHkRF;AG/QA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,4CAAA;AHiRF;AG9QA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mDAAA;AHgRF;AG7QA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,uDAAA;AH+QF;AG5QA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kDAAA;AH8QF;AG3QA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,sDAAA;AH6QF;AG1QA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,oDAAA;AH4QF;AGzQA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,8CAAA;AH2QF;AGxQA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mDAAA;AH0QF;AGvQA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,wDAAA;AHyQF;AGtQA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kDAAA;AHwQF;AI5XA;;;;;uBAAA;AJEA;EACI,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;EACA,mBAAA;EACA,WAAA;AAkYJ;;AA/XA;EACE,aAAA;EACA,uBAAA;EACA,YAAA;EACA,yBAAA;EACA,0BAAA;AAkYF;;AA/XA;EACI,oCAAA;EACA,8BAAA;AAkYJ;;AA/XA;EACE,kBAAA;EACA,yBInBW;EJoBX,YAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;AAkYF;;AA/XA;EACE,uBAAA;EACA,cI5BW;AJ8Zb;;AA9XA;EACI,iBAAA;EACA,iBAAA;EACA,yBInCS;EJoCT,yBAAA;EACA,YAAA;EACA,YAAA;EACA,mBAAA;EACA,eAAA;AAiYJ;AA/XI;EACI,sBAAA;EACA,cI5CK;EJ8CL,yBAAA;AAgYR;;AA5XA;EACI,YAAA;EACA,eAAA;AA+XJ;;AA3XA;EACI,aAAA;EACA,eAAA;EACA,uBAAA;EACA,mBAAA;EACA,8BAAA;EACA,eAAA;EACA,yBAAA;EACA,kBAAA;EACA,YAAA;AA8XJ;;AA3XA;EACI,aAAA;EACA,UAAA;EACA,YAAA;EACA,gBAAA;EACA,WAAA,EAAA,uCAAA;EACA,eAAA;EACA,sBAAA;EACA,mBAAA;AA8XJ;;AA3XA;EACI,WAAA,EAAA,6BAAA;AA8XJ;;AA3XA;EACI,WAAA,EAAA,sCAAA;EACA,iBAAA;EACA,0BAAA,EAAA,mCAAA;AA8XJ;;AA3XA;EACI,cI1FS;EJ2FT,cAAA;EACA,iBAAA;AA8XJ;;AA1XA;EACI,aAAA;EACA,sBAAA;EACA,mBAAA;AA6XJ;;AA1XA;EACI,kBAAA,EAAA,wCAAA;EACA,eAAA;AA6XJ;;AA1XA;EACI,kBAAA;EACA,mBAAA;AA6XJ;;AA1XA;EACI,uBAAA;EACA,mBAAA;EACA,aAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,aAAA;EACA,uBAAA;EACA,uBAAA;EACA,wCAAA;EACA,gBAAA;EACA,kBAAA;AA6XJ;;AA1XA;EACI,aAAA;EACA,sBAAA;EACA,8BAAA;AA6XJ;;AAzXA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,WAAA;AA4XF;;AAzXA;EACE,YAAA,EAAA,iBAAA;EACA,WAAA,EAAA,iBAAA;EACA,iBAAA,EAAA,qBAAA;EACA,kBAAA,EAAA,yBAAA;EACA,yBI7IW,EJ6IoB,mBAAA;EAC/B,0CAAA;AA4XF;;AAzXA;EACE,eAAA;AA4XF;;AAzXA;EACE,sBAAA;AA4XF;;AAzXA;EACE,sBAAA;AA4XF;;AAzXA;EACE,qBAAA;AA4XF;;AAzXA;EACE;IACE,qBAAA;IACA,yBIpKS,EJoKsB,mBAAA;IAC/B,0CAAA,EAAA,uBAAA;EA4XF;EAzXA;IACE,qBAAA;IACA,yBIzKa,EJyKsB,wBAAA;IACnC,6CAAA,EAAA,wBAAA;EA2XF;EAxXA;IACE,qBAAA;IACA,yBIhLS,EJgLsB,oBAAA;IAC/B,0CAAA,EAAA,uBAAA;EA0XF;AACF;AAvXA,6DAAA;AACA;EACI,WAAA;EACA,6BAAA;EACA,kBAAA;EACA,mBAAA;EACA,sBAAA;AAyXJ;;AAtXA,4BAAA;AACA;EACI,WAAA;EACA,aAAA;AAyXJ;;AAtXA;EACI,uBAAA;EACA,mBAAA;AAyXJ;;AAtXA;EACI,oCAAA;EACA,mBAAA;EACA,uBAAA;AAyXJ;;AAtXA;EACI,oCAAA;AAyXJ;;AAtXA,YAAA;AACA;EACI,WAAA;EACA,2BAAA;EACA,UAAA;EACA,gBAAA;EACA,YAAA;AAyXJ;;AAtXA;;EAEI,SAAA;EACA,UAAA;EACA,aAAA;EACA,8BAAA;AAyXJ;;AAtXA;;EAEI,SAAA;EACA,eAAA;EACA,mBAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,UAAA;EACA,sBAAA;EACA,kBAAA,EAAA,oBAAA;EACA,kBAAA;AAyXJ;AAxXI;EAbJ;;IAcQ,eAAA;EA4XN;AACF;AA3XI;EAhBJ;;IAiBQ,eAAA;EA+XN;AACF;;AA5XA;EACI,qBAAA,EAAA,oBAAA;EACA,YAAA,EAAA,oBAAA;EACA,YAAA;EACA,yBI3PM;EJ4PN,WAAA;EACA,4BAAA;EACA,mBAAA;EACA,uBAAA;AA+XJ;;AA5XA;EACI,SAAA;EACA,UAAA;EACA,aAAA;EACA,8BAAA;AA+XJ;;AA5XA;EACI,SAAA;EACA,eAAA;EACA,mBAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,UAAA;EACA,sBAAA;EACA,kBAAA,EAAA,oBAAA;EACA,kBAAA;AA+XJ;AA9XI;EAZJ;IAaQ,eAAA;EAiYN;AACF;AAhYI;EAfJ;IAgBQ,eAAA;EAmYN;AACF;;AAhYA;EACI,eAAA,EAAA,oBAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,6BAAA;EACA,6BAAA;AAmYJ;;AAhYA;EACI,yBIhTS;EJiTT,WAAA;EACA,YAAA;AAmYJ;AAlYI;EAJJ;IAKQ,YAAA;EAqYN;AACF;AApYI;EAPJ;IAQQ,aAAA;EAuYN;AACF;;AApYA;EACI,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAuYJ;;AApYA;EACI,aAAA;EACA,uBAAA,EAAA,+BAAA;EACA,mBAAA,EAAA,2BAAA;AAuYJ;;AApYA;EACI,eAAA,EAAA,iEAAA;EACA,gBAAA,EAAA,+DAAA;EACA,gBAAA;AAuYJ;;AApYA;EACI,gBAAA;EACA,wBAAA;EACA,WAAA;EACA,iBAAA,EAAA,6BAAA;EACA,gCAAA,EAAA,mBAAA;EACA,sBAAA;EACA,yBAAA;EACA,sBAAA;EACA,WAAA;EACA,eAAA;EACA,kBAAA,EAAA,gBAAA;AAuYJ;;AAnYA;EACI,0CAAA;EACA,2CAAA;EACA,sCAAA;EACA,QAAA;AAsYJ;;AAnYA;EACI,0CAAA;EACA,2CAAA;EACA,mCAAA;EACA,QAAA;AAsYJ;;AAnYA;EACI,gBAAA,EAAA,gCAAA;EACA,uBAAA;EACA,qBAAA;AAsYJ;;AAnYA;EACI,aAAA;EACA,2BAAA;EACA,uBAAA;EACA,iBAAA;EACA,YAAA;EACA,SAAA;EACA,mBAAA;EACA,SAAA;EACA,YAAA;AAsYJ;;AAnYA;EACI,iBAAA;EACA,yBIvXM;EJwXN,YAAA;EACA,YAAA;EACA,eAAA;EACA,mBAAA;EACA,mBAAA;EACA,cAAA;EACA,WAAA;EACA,kBAAA;EACA,wCAAA;AAsYJ;;AApYA;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;AAuYJ;;AAnYA;EACI,aAAA;EAEA,aAAA;EACA,aAAA;EAEA,uBAAA;AAoYJ;;AAhYA;EACI,cAAA;AAmYJ;;AAhYA;EACI,mBAAA;EACA,kBAAA;EACA,aAAA;EACA,eAAA;EACA,qBAAA;EACA,yBAAA;EACA,sBAAA;EACA,2CAAA;EACA,gBAAA;EAEA,eAAA;EACA,cAAA,EAAA,sCAAA;EACA,uBAAA,EAAA,6BAAA;AAkYJ;;AA/XA;EACI,cAAA;EACA,kBAAA;AAkYJ;;AA/XA;EACI,aAAA;AAkYJ;;AA/XA;EACI,aAAA;EACA,eAAA;EACA,mBAAA;EACA,uBAAA;EACA,qBAAA;EACA,YAAA;EACA,iBAAA;EACA,sBAAA;EACA,iCAAA;AAkYJ;;AA/XA;EACI,sBAAA;EACA,gBAAA;AAkYJ;;AA/XA;EACI,aAAA;EACA,sBAAA;EACA,SAAA,EAAA,6BAAA;AAkYJ;;AA/XA;EACI,uBAAA;EACA,mBAAA;EACA,wCAAA;EACA,gBAAA;AAkYJ;;AA/XA;EACI,yBIvdQ;EJwdR,WAAA;EACA,mBAAA;EACA,kBAAA;EACA,wCAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,YAAA,EAAA,2CAAA;AAkYJ;;AA/XA;EACI,SAAA;EACA,iBAAA;AAkYJ;;AA/XA;EACI,wBAAA;AAkYJ;;AA/XA;EAEI,YAAA;AAiYJ;;AA9XA;EACE,UAAA;EACA,aAAA;EACA,aAAA;AAiYF;;AA7XA;EACI,sBAAA,EAAA,qCAAA;EACA,WAAA,EAAA,qBAAA;EACA,sBAAA,EAAA,gBAAA;AAgYJ;;AA5XA;EACI,sBAAA,EAAA,yBAAA;EACA,WAAA,EAAA,mCAAA;AA+XJ;;AA1XI;EAEI,kBAAA;EACA,8BAAA;AA4XR;AA1XQ;EACI,aAAA;EACA,sBAAA;EACA,mBAAA;AA4XZ;AA1XY;EACI,eAAA;EACA,WAAA;EACA,kBAAA;AA4XhB;AAxXQ;EACI,YAAA;EACA,kBAAA;AA0XZ;AAtXY;EACI,yBAAA;EACA,sBAAA;EACA,kBAAA;EACA,iBAAA;EACA,eAAA;EACA,eAAA;EACA,WAAA;EACA,gBAAA;EACA,gBAAA;EACA,WAAA,EAAA,gDAAA;EACA,gBAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,aAAA;AAwXhB;AArXgB;EACI,eAAA;EACA,WAAA;EACA,+BAAA;AAuXpB;AApXgB;EACI,yBAAA;AAsXpB;AAlXY;EACI,kBAAA;EACA,SAAA;EACA,OAAA;EACA,UAAA,EAAA,+CAAA;EACA,iBAAA;EACA,gBAAA;EACA,sBAAA;EACA,sBAAA;EACA,kBAAA;EACA,wCAAA;EACA,aAAA;EACA,aAAA;EACA,eAAA;EACA,SAAA,EAAA,iDAAA;EACA,2BAAA,EAAA,uDAAA;EACA,qBAAA;AAoXhB;AAlXgB;EACI,aAAA;EACA,mBAAA;EACA,8BAAA;EAEA,eAAA;EACA,cAAA;AAmXpB;AAjXoB;EACI,gBAAA;AAmXxB;AAhXoB;EACI,yBAAA;AAkXxB;;AA1WA;EACI,aAAA;EACA,eAAA;EACA,QAAA;EACA,eAAA;EACA,kBAAA;EACA,uBAAA;AA6WJ;AA3WI;EACI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,WAAA;AA6WR;AA3WQ;EACI,gBAAA;EACA,eAAA;EACA,eAAA;EACA,WAAA;AA6WZ;AA3WY;EACI,WAAA;AA6WhB;;AAvWA;EACE,aAAA;EACA,mBAAA,EAAA,kCAAA;EACA,iBAAA,EAAA,gCAAA;EACA,kBAAA;AA0WF;AAxWE;EACE,eAAA;EACA,cEjnBS;EFknBT,2BAAA;AA0WJ;;AAtWA;EACE,cIvoBe;AJg/BjB;;AArWA;EACE;IACE,WAAA;EAwWF;AACF;AArWA;EACI;IACI,SAAA;EAuWN;EArWM;IACI,eAAA,EAAA,6CAAA;IACA,gBAAA,EAAA,gCAAA;IACA,gBAAA,EAAA,gCAAA;EAuWV;EAlWc;IACI,0BAAA,EAAA,iCAAA;IACA,WAAA;IACA,eAAA;IACA,gBAAA;EAoWlB;EAhWc;IACI,kBAAA;IACA,SAAA;IACA,UAAA,EAAA,+CAAA;EAkWlB;EA7VsB;IACI,gBAAA;EA+V1B;EA5VsB;IACI,yBAAA;EA8V1B;EAtVA;IACE,WAAA;EAwVF;AACF;AAnVA,yCAAA;AACA;EACI;IACI,kBAAA;IACA,kBAAA;IACA,eAAA;EAqVN;EAlVE;IACI,eAAA;IACA,kBAAA;EAoVN;EAjVE;IACI,gBAAA;IACA,kBAAA;EAmVN;EA/UE;IACI,uBAAA;IACA,WAAA;IACA,kBAAA;EAiVN;EA7UE;IACI,cAAA;IACA,SAAA;IACA,kBAAA;EA+UN;EA7UE;IACI,OAAA,EAAA,sBAAA;IACA,eAAA;IACA,eAAA,EAAA,0CAAA;IACA,mBAAA;EA+UN;EA5UK;IACC,SAAA;EA8UN;EA7UM;IACI,eAAA,EAAA,6CAAA;IACA,gBAAA,EAAA,gCAAA;IACA,gBAAA,EAAA,gCAAA;EA+UV;EA3Uc;IACI,0BAAA,EAAA,iCAAA;IACA,WAAA;IACA,eAAA;IACA,gBAAA;IAEA,YAAA;EA4UlB;EAzUY;IACE,UAAA;EA2Ud;EAzUY;IACE,0BAAA;EA2Ud;EAtUE;IACE,WAAA;IACA,aAAA;EAwUJ;EApUE;IACI,uBAAA;IACA,YAAA,EAAA,2CAAA;EAsUN;AACF","sourcesContent":["/** Colors variables */\r\n\r\n$sb-primary: #2E4057 !default;\r\n$sb-accent: #fff !default;\r\n$sb-facebook: #4267B2 !default;\r\n$sb-twitter: #00acee !default;\r\n$sb-google: #db4437 !default;\r\n$sb-mix: #ff8226 !default;\r\n$sb-linkedin: #006fa6 !default;\r\n$sb-pinterest: #bd081c !default;\r\n$sb-reddit: #ff4006 !default;\r\n$sb-tumblr: #36465d !default;\r\n$sb-whatsapp: #25d366 !default;\r\n$sb-messenger: #0080FF !default;\r\n$sb-telegram: #0088cc !default;\r\n$sb-xing: #006567 !default;\r\n$sb-email: #FF961C !default;\r\n$sb-viber: #665ca7 !default;\r\n$sb-vk: #4C75A3 !default;\r\n$sb-copy: #607D8B !default;\r\n$sb-print: #765AA2 !default;\r\n$sb-sms: #20c16c !default;\r\n$sb-gray: #a5a5a5 !default;\r\n$sb-expand: #FF6651 !default;\r\n$sb-line: #00b900 !default;\r\n\r\n$sb-buttons: (\r\n  facebook: $sb-facebook,\r\n  twitter: $sb-twitter,\r\n  google: $sb-google,\r\n  mix: $sb-mix,\r\n  line: $sb-line,\r\n  linkedin: $sb-linkedin,\r\n  pinterest: $sb-pinterest,\r\n  reddit: $sb-reddit,\r\n  tumblr: $sb-tumblr,\r\n  whatsapp: $sb-whatsapp,\r\n  messenger: $sb-messenger,\r\n  telegram: $sb-telegram,\r\n  xing: $sb-xing,\r\n  sms: $sb-sms,\r\n  email: $sb-email,\r\n  viber: $sb-viber,\r\n  vk: $sb-vk,\r\n  copy: $sb-copy,\r\n  print: $sb-print,\r\n  expand: $sb-expand\r\n) !default;\r\n","@import \"variables\";\r\n\r\n.sb-default .sb-wrapper {\r\n  --sb-color: #{$sb-accent};\r\n  --sb-background: var(--button-color);\r\n  --sb-border-radius: 4px;\r\n  --sb-overflow: hidden;\r\n\r\n  &.sb-show-icon.sb-show-text {\r\n    --sb-text-padding: 0 1em 0 0;\r\n\r\n    .sb-text {\r\n      filter: none;\r\n    }\r\n  }\r\n}\r\n","@import \"/src/styles.scss\";\n@import \"/node_modules/flag-icons/css/flag-icons.min.css\";\n@import \"placeholders/flexboxes\";\n@import \"placeholders/fonts\";\n@import \"placeholders/quickStyles\";\n@import \"variables/breakpoints\";\n@import \"variables\";\n\n\n.button-container {\n    display: flex;\n    justify-content:center;\n    align-items: center;\n    margin-top: 10px;\n    margin-bottom: 10px;\n    width: 100%;\n}\n\n.raised-footer {\n  display: flex;\n  justify-content: center;\n  padding: 4px;\n  background-color: #e1e3e4;\n  border-top: 1px solid #ddd;\n}\n\n.disabled {\n    background-color: $theme-3 !important;\n    cursor:not-allowed !important;\n}\n\n.view-toggle-btn {\n  padding: 10px 20px;\n  background-color: $accent-btn;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n}\n\n.view-toggle-btn:hover {\n  background-color: white;\n  color: $accent-btn;\n}\n\n\n.filter-button {\n    margin-left: 10px; // Space between buttons\n    padding: 5px 10px; // Padding for buttons\n    background-color: $accent-btn; // Button background colo\n    border: 1px solid $accent-btn;\n    color: white; // Button text color\n    border: none; // Remove default border\n    border-radius: 25px; // Rounded corners\n    cursor: pointer; // Pointer cursor on hover\n\n    &:hover {\n        background-color: #fff; // Darker shade on hover\n        color: $accent-btn;\n\n        border: 1px solid $accent-btn;\n    }\n}\n\n.spacer {\n    flex-grow: 1;\n    min-width: 10px;\n}\n\n\n.alphabet-filter {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: center;\n    margin-bottom: 20px;\n    font-family: Arial, sans-serif;\n    font-size: 18px;\n    border: 1px solid #caced1;\n    border-radius: 5px;\n    padding: 5px;\n}\n\n.letter-button {\n    margin: 0 3px;\n    padding: 0;\n    border: none;\n    background: none;\n    color: #ccc;  /* Muted color for non-active letters */\n    cursor: pointer;\n    transition: color 0.3s;\n    font-weight: normal;\n}\n\n.letter-button:hover {\n    color: #666;  /* Slightly darker on hover */\n}\n\n.active-letter {\n    color: #000;  /* Black color for the active letter */\n    font-weight: bold;\n    text-decoration: underline;  /* Optional: to make it stand out */\n}\n\n.search-note {\n    color:$accent-btn;\n    font-size: 9pt;\n    font-weight: bold;\n\n}\n\n.centered-label {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n}\n\n.centered-label label {\n    margin-bottom: 5px; /* Adds space between label and select */\n    font-size: 10pt;\n}\n\n.note-container{\n    text-align: center;\n    margin-bottom: 20px;\n}\n\n.full-page-container {\n    background-color: white;\n    border-radius: 15px;\n    padding: 20px;\n    width: 72vw;\n    margin: auto;\n    margin-bottom: 10px;\n    display: flex;\n    justify-content: center;\n    align-items: flex-start;\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n    overflow: hidden;\n    position: relative;\n}\n\n.loader-container {\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n}\n\n\n.dots-container {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 100%;\n  width: 100%;\n}\n\n.dot {\n  height: 12px; /* Reduced size */\n  width: 12px; /* Reduced size */\n  margin-right: 6px; /* Adjusted spacing */\n  border-radius: 6px; /* Matches smaller size */\n  background-color: $theme-main; /* Starts as pink */\n  animation: pulse 1.5s infinite ease-in-out;\n}\n\n.dot:last-child {\n  margin-right: 0;\n}\n\n.dot:nth-child(1) {\n  animation-delay: -0.3s;\n}\n\n.dot:nth-child(2) {\n  animation-delay: -0.1s;\n}\n\n.dot:nth-child(3) {\n  animation-delay: 0.1s;\n}\n\n@keyframes pulse {\n  0% {\n    transform: scale(0.8);\n    background-color: $theme-main; /* Starts as pink */\n    box-shadow: 0 0 0 0 rgba($theme-main, 0.5); /* Subtle pink shadow */\n  }\n\n  50% {\n    transform: scale(1.2);\n    background-color: $theme-contrast; /* Transitions to blue */\n    box-shadow: 0 0 0 3px rgba($theme-contrast, 0.2); /* Smaller blue shadow */\n  }\n\n  100% {\n    transform: scale(0.8);\n    background-color: $theme-main; /* Returns to pink */\n    box-shadow: 0 0 0 0 rgba($theme-main, 0.5); /* Subtle pink shadow */\n  }\n}\n\n/* Wrapper inside full-page-container for scrolling content */\n.scrollable-content {\n    width: 100%;\n    max-height: calc(90vh - 40px);\n    overflow-y: scroll;\n    padding-right: 20px;\n    box-sizing: border-box;\n}\n\n/* Custom scrollbar styles */\n.scrollable-content::-webkit-scrollbar {\n    width: 12px;\n    display: none;\n}\n\n.scrollable-content::-webkit-scrollbar-track {\n    background: transparent;\n    border-radius: 15px;\n}\n\n.scrollable-content::-webkit-scrollbar-thumb {\n    background-color: rgba(0, 0, 0, 0.2);\n    border-radius: 15px;\n    border: 3px solid white;\n}\n\n.scrollable-content::-webkit-scrollbar-thumb:hover {\n    background-color: rgba(0, 0, 0, 0.4);\n}\n\n/* Wrapper */\n.wrapper {\n    width: 70vw;\n    margin: auto auto 10vh auto;\n    padding: 0;\n    background: #fff;\n    color: black;\n}\n\n.title-row ul,\n.row ul {\n    margin: 0;\n    padding: 0;\n    display: flex;\n    justify-content: space-between;\n}\n\n.title-row ul li,\n.row ul li {\n    margin: 0;\n    font-size: 16px;\n    font-weight: normal;\n    list-style: none;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 20%;\n    box-sizing: border-box;\n    padding: 10px 10px; /* Reduced padding */\n    text-align: center;\n    @media only screen and (max-width: 767px) and (min-width: 480px) {\n        font-size: 13px;\n    }\n    @media only screen and (max-width: 479px) {\n        font-size: 13px;\n    }\n}\n\n.title {\n    padding: 20px 0 5px 0; /* Reduced padding */\n    height: 40px; /* Adjusted height */\n    font-size: 0;\n    background-color: $theme-1;\n    color: #fff;\n    border-left: 1px solid lighten($theme-back, 100%);\n    align-items: center;\n    justify-content: center;\n}\n\n.row ul {\n    margin: 0;\n    padding: 0;\n    display: flex;\n    justify-content: space-between;\n}\n\n.row ul li {\n    margin: 0;\n    font-size: 16px;\n    font-weight: normal;\n    list-style: none;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 20%;\n    box-sizing: border-box;\n    padding: 10px 10px; /* Reduced padding */\n    text-align: center;\n    @media only screen and (max-width: 767px) and (min-width: 480px) {\n        font-size: 13px;\n    }\n    @media only screen and (max-width: 479px) {\n        font-size: 13px;\n    }\n}\n\n.row {\n    padding: 15px 0; /* Reduced padding */\n    height: 30px;\n    font-size: 0;\n    position: relative;\n    overflow: hidden;\n    transition: all 0.2s ease-out;\n    border-top: 1px solid $theme-lightgray;\n}\n\n.row:hover {\n    background-color: $accent-btn;\n    color: #fff;\n    height: 65px;\n    @media only screen and (max-width: 767px) {\n        height: 85px;\n    }\n    @media only screen and (max-width: 359px) {\n        height: 105px;\n    }\n}\n\n.row ul li {\n    padding: 5px 10px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.row-filter {\n    display: flex;\n    justify-content: center; /* Adjust alignment as needed */\n    align-items: center; /* Align items vertically */\n}\n\n.custom-select {\n    flex: 1 1 150px; /* Allow the dropdowns to grow and shrink, with a minimum width */\n    min-width: 150px; /* Set a minimum width to prevent them from getting too small */\n    max-width: 200px;\n}\n\n.custom-select select {\n    appearance: none;\n    -webkit-appearance: none;\n    width: 100%;\n    font-size: 0.8rem; /* Adjust font size smaller */\n    padding: 0.675em 1em 0.675em 1em; /* Adjust padding */\n    background-color: #fff;\n    border: 1px solid #caced1;\n    border-radius: 0.25rem;\n    color: #000;\n    cursor: pointer;\n    text-align: center; /* Center text */\n}\n\n\n.custom-select::before {\n    border-left: var(--size) solid transparent;\n    border-right: var(--size) solid transparent;\n    border-bottom: var(--size) solid black;\n    top: 55%;\n}\n\n.custom-select::after {\n    border-left: var(--size) solid transparent;\n    border-right: var(--size) solid transparent;\n    border-top: var(--size) solid black;\n    top: 75%;\n}\n\n.container-filter {\n    margin-top: 20px; /* Adjust top margin as needed */\n    justify-content: center;\n    align-content: center ;\n}\n\n.select-container {\n    display: flex;\n    justify-content: flex-start;\n    align-items: flex-start;\n    flex-wrap: nowrap;\n    padding: 5px;\n    gap: 10px;\n    flex-direction: row;\n    gap: 10px;\n    flex-grow: 0;\n}\n\n.dropdown-btn {\n    padding: 3px 20px;\n    background-color: $theme-1;\n    color: white;\n    border: none;\n    cursor: pointer;\n    border-radius: 25px;\n    margin-bottom: 20px;\n    display: block;\n    width: 100%;\n    text-align: center;\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n.filter-icons {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    align-items: center;\n}\n\n\n.dropdown-container {\n    display: none;\n    // border: 1px solid #caced1;\n    width: 68.5vw;\n    padding: 10px;\n    // border-radius: 5px;\n    background-color: white;\n\n}\n\n.dropdown-container.show {\n    display: block;\n}\n\n.radio-inputs {\n    align-items: center;\n    position: relative;\n    display: flex;\n    flex-wrap: wrap;\n    border-radius: 0.5rem;\n    background-color: #e1e3e4;\n    box-sizing: border-box;\n    box-shadow: 0 0 0px 1px rgba(0, 0, 0, 0.06);\n    padding: 0.25rem;\n    // width: 300px;\n    font-size: 14px;\n    margin: 0 auto; /* Center the container horizontally */\n    justify-content: center; /* Center the radio buttons */\n}\n\n.radio-inputs .radio {\n    flex: 1 1 auto;\n    text-align: center;\n}\n\n.radio-inputs .radio input {\n    display: none;\n}\n\n.radio-inputs .radio .name {\n    display: flex;\n    cursor: pointer;\n    align-items: center;\n    justify-content: center;\n    border-radius: 0.5rem;\n    border: none;\n    padding: .5rem 0;\n    color: rgba(51, 65, 85, 1);\n    transition: all .15s ease-in-out;\n}\n\n.radio-inputs .radio input:checked + .name {\n    background-color: #fff;\n    font-weight: 600;\n}\n\n.main-container {\n    display: flex;\n    flex-direction: column;\n    gap: 20px; /* Space between containers */\n}\n\n.raised-container {\n    background-color: white;\n    border-radius: 15px;\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n    overflow: hidden;\n}\n\n.raised-header {\n    background-color:  $dark-text;\n    color: #fff;\n    border-radius: 15px;\n    padding: 10px 20px;\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n    margin-bottom: 10px;\n    display: flex;\n    align-items: center;\n    height: 60px; /* Ensure the same height for all headers */\n}\n\n.raised-header h2 {\n    margin: 0;\n    font-size: 1.5rem;\n}\n\n.row-wrapper {\n    margin: 0 20px 15px 20px;\n}\n\n.no-results {\n\n    margin: 30px;\n}\n\n.no-scroll-results {\n  color: red;\n  font-size: px;\n  margin: 100px;\n}\n\n\n.reset-button {\n    background-color: #ccc; /* Grey background for Reset button */\n    color: #000; /* Black text color */\n    border: 1px solid #ccc; /* Grey border */\n    // margin-bottom: 10px; /* Space below the Reset button */\n}\n\n.reset-button:hover {\n    background-color: #bbb; /* Darker grey on hover */\n    color: #000; /* Keep text color black on hover */\n}\n\n.select-container {\n\n    .custom-select {\n\n        position: relative;\n        font-family: Arial, sans-serif;\n\n        .centered-label {\n            display: flex;\n            flex-direction: column;\n            align-items: center;\n\n            label {\n                font-size: 14px;\n                color: #333;\n                margin-bottom: 4px;\n            }\n        }\n\n        .checkbox-dropdown {\n            height: 35px;\n            position: relative;\n\n\n\n            .dropdown-btn {\n                background-color: #f0f0f5;\n                border: 1px solid #ccc;\n                border-radius: 8px;\n                padding: 8px 13px;\n                cursor: pointer;\n                font-size: 14px;\n                color: #333;\n                min-width: 170px;\n                max-width: 200px;\n                width:10vw; /* Ensure button takes full width of container */\n                text-align: left;\n                display: flex;\n                justify-content: space-between;\n                align-items: center;\n                z-index: 1000;\n\n                // Arrow style for open and close\n                .arrow {\n                    font-size: 12px;\n                    color: #666;\n                    transition: transform 0.3s ease;\n                }\n\n                &:hover {\n                    background-color: #e0e0e5;\n                }\n            }\n\n            .checkbox-list {\n                position: absolute;\n                top: 100%;\n                left: 0;\n                width: 80%; /* Set width to 100% to match dropdown button */\n                max-height: 200px;\n                overflow-y: auto;\n                background-color: #fff;\n                border: 1px solid #ccc;\n                border-radius: 8px;\n                box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n                z-index: 1000;\n                padding: 10px;\n                margin-top: 4px;\n                left: 50%; /* Start positioning from the horizontal center */\n                transform: translateX(-50%); /* Shift back by 50% of the element's width to center */\n                scrollbar-width: thin;\n\n                .checkbox-item {\n                    display: flex;\n                    align-items: center;\n                    justify-content: space-between;\n\n                    font-size: 14px;\n                    padding: 4px 0;\n\n                    input[type=\"checkbox\"] {\n                        margin-left: 8px;\n                    }\n\n                    &:hover {\n                        background-color: #f5f5f5;\n                    }\n                }\n            }\n        }\n    }\n}\n\n.selected-chips {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 8px;\n    margin-top: 8px; // Adjust margin if necessary\n    margin-bottom: 0px; // Ensure there's space below\n    justify-content: center;\n\n    .chip {\n        display: flex;\n        align-items: center;\n        background-color: #f0f0f5;\n        border: 1px solid #ccc;\n        border-radius: 16px;\n        padding: 4px 8px;\n        font-size: 14px;\n        color: #333;\n\n        .remove-chip {\n            margin-left: 8px;\n            cursor: pointer;\n            font-size: 14px;\n            color: #666;\n\n            &:hover {\n                color: #333;\n            }\n        }\n    }\n}\n\n.card-arrow {\n  display: flex;\n  align-items: center; /* Center the chevron vertically */\n  margin-left: auto; /* Push the arrow to the right */\n  margin-right: 10px;\n\n  mat-icon {\n    font-size: 24px;\n    color: $theme-back;\n    transition: color 0.3s ease;\n  }\n}\n\n.material-symbols-outlined:hover {\n  color: $theme-contrast;\n}\n\n\n@media (max-width: 1350px) {\n  .selected-chips {\n    width: 13vw;\n  }\n}\n\n@media (max-width: 1150px) {\n    .select-container {\n        gap: 10px;\n\n        .custom-select {\n            flex: 1 1 170px; /* Adjust the flex-basis to make it smaller */\n            min-width: 170px; /* Set a smaller minimum width */\n            max-width: 170px; /* Set a smaller maximum width */\n\n\n            .checkbox-dropdown {\n\n                .dropdown-btn {\n                    font-size: 14px !important; /* Make the button text smaller */\n                    width:17vw;\n                    min-width: 70px;\n                    max-width: 170px;\n                    //margin: 10px;\n                }\n\n                .checkbox-list {\n                    position: absolute;\n                    top: 130%;\n                    width: 86%; /* Set width to 100% to match dropdown button */\n\n                    .checkbox-item {\n                        //font-size: 9px;\n\n                        input[type=\"checkbox\"] {\n                            margin-left: 8px;\n                        }\n\n                        &:hover {\n                            background-color: #f5f5f5;\n                        }\n                    }\n                }\n            }\n        }\n    }\n\n  .selected-chips {\n    width: 10vw;\n    //display: none;\n\n  }\n}\n\n/* Three-wide Layout for Larger Screens */\n@media (max-width: 1000px) {\n    .row-filter {\n        margin-bottom: 0px;\n        margin-right: 10px;\n        min-width: 70vw;\n    }\n\n    .button-container {\n        min-width: 69vw;\n        margin-right: 18px;\n    }\n\n    .filter-button{\n        margin-left: 0px;\n        margin-right: 18px;\n    }\n\n\n    .dropdown-container {\n        justify-content: center;\n        width: 65vw;\n        margin-right: 18px;\n\n    }\n\n    .select-container {\n        display: block;\n        margin: 0;\n        margin-right: 18px;\n    }\n    .custom-select {\n        flex: 1; /* Allow flexibility */\n        min-width: 60vw;\n        max-width: 60vw; /* Three-wide layout with gap adjustment */\n        margin-bottom: 10px;\n    }\n\n       .select-container {\n        gap: 10px;\n        .custom-select {\n            flex: 1 1 110px; /* Adjust the flex-basis to make it smaller */\n            min-width: 110px; /* Set a smaller minimum width */\n            max-width: 110px; /* Set a smaller maximum width */\n\n\n            .checkbox-dropdown {\n                .dropdown-btn {\n                    font-size: 14px !important; /* Make the button text smaller */\n                    width:60vw;\n                    min-width: 70px;\n                    max-width: 570px;\n\n                    margin: 10px;\n                }\n\n              .checkbox-list {\n                width: 90%;\n              }\n              .checkbox-item {\n                font-size: 14px !important;\n              }\n            }\n        }\n    }\n    .selected-chips {\n      width: 60vw;\n      padding: 10px;\n        //display: none;\n\n    }\n    .raised-header {\n        justify-content: center;\n        height: 30px; /* Ensure the same height for all headers */\n    }\n}\n","@import \"variables\";\r\n\r\n$sb-text-shadow: 0 1px 1px rgba(0, 0, 0, 0.3);\r\n$sb-text-size: 0.8em;\r\n\r\n.sb-circles-dark, .sb-circles-light {\r\n  .sb-wrapper {\r\n    --sb-color: #{$sb-accent};\r\n    --sb-background: transparent;\r\n    --sb-min-width: fit-content;\r\n    --sb-height: fit-content;\r\n    --sb-icon-size: 1.4em;\r\n\r\n    &:active {\r\n      .sb-icon {\r\n        box-shadow: 0 7px 8px -4px rgba(0, 0, 0, .2), 0 12px 17px 2px rgba(0, 0, 0, .14), 0 5px 22px 4px rgba(0, 0, 0, .12);\r\n      }\r\n    }\r\n\r\n    .sb-icon {\r\n      background-color: var(--button-color);\r\n      box-shadow: 0 3px 5px -1px rgba(0, 0, 0, .2), 0 6px 10px 0 rgba(0, 0, 0, .14), 0 1px 18px 0 rgba(0, 0, 0, .12);\r\n      width: 2.5em;\r\n      min-height: 2.5em;\r\n      border-radius: 50%;\r\n      transition: background .4s cubic-bezier(.25, .8, .25, 1), box-shadow 280ms cubic-bezier(.4, 0, .2, 1);\r\n    }\r\n\r\n    .sb-text {\r\n      color: var(--button-color);\r\n      font-size: $sb-text-size;\r\n      margin-top: 5px;\r\n      border-radius: 1em;\r\n      width: 100%;\r\n      height: 1.8em;\r\n      line-height: 1.8em;\r\n      padding: 0;\r\n      transition: background .4s cubic-bezier(.25, .8, .25, 1), box-shadow 280ms cubic-bezier(.4, 0, .2, 1);\r\n    }\r\n\r\n    .sb-content {\r\n      align-items: center;\r\n      flex-direction: column;\r\n    }\r\n  }\r\n}\r\n\r\n.sb-circles-dark .sb-wrapper {\r\n\r\n  .sb-icon {\r\n    background-color: var(--button-color);\r\n  }\r\n\r\n  .sb-text {\r\n    color: var(--button-color);\r\n  }\r\n}\r\n\r\n.sb-circles-light .sb-wrapper {\r\n\r\n  .sb-icon, .sb-text {\r\n    color: var(--button-color);\r\n  }\r\n\r\n  .sb-icon {\r\n    background: radial-gradient(ellipse farthest-corner at center, white 30%, darken(white, 5%) 100%);\r\n  }\r\n}\r\n","\n@import \"../node_modules/ngx-sharebuttons/themes/default.scss\";\n@import \"../node_modules/ngx-sharebuttons/themes/circles.scss\";\n\n/* You can add global styles to this file, and also import other style files */\n\nbody, html {\nheight: 100vh;\n// width: 100vh;\nmargin: 0;\n}\n\nbody {\n    font-family: Arial, sans-serif;\n    height: 100vh;\n    background-color: #fff; /* Background color for the top half */\n    position: relative;\n    display: block;\n    justify-content: center;\n    align-items: center;\n    }\n\n\nbody::after {\n    content: \"\";\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    width: 100%;\n    height: 50%;\n    background: #fff;\n\n\n    z-index: -1; /* Ensure the gradient is behind other content */\n}\n\n\n$theme-back: #2D2D2A;\n/* Old palette\n$theme-main: #B05995;\n$theme-contrast: #3792BF;\n$theme-1: #282B59;\n$theme-2: #D683DD;\n$theme-3: #27567A;\n$theme-4: #44DDC4;\n$theme-5: #3336AE;\n$theme-6: #18C43D;\n*/\n\n$theme-main: #1B3E78;\n$theme-contrast: #0CAD99;\n$theme-1: #3792BF;\n$theme-2: #AACCFF;\n$theme-3: #BDBDBD;\n$theme-4: #7D7979;\n$theme-5: #787c95;\n\n$theme-primary: #3792BF;\n$theme-secondary: #1B3E78;\n$theme-color3: #AACCFF;\n$theme-color4: #BDBDBD;\n$theme-color5: #7D7979;\n$theme-accent: #0CAD99;\n$text-gray:#787c95;\n$theme-red:#d9534f;\n\n$theme-back-light: #4c4c47;\n$theme-lightgray: #e7e7e7;\n$theme-gray-text: #787476;\n\n$theme-table-header: #f6f6f6;\n$theme-table-body:#f8f8f8;\n$theme-source:#9E9E9E;\n\n\n$value-chain-1: #44DDC4;\n$value-chain-2: \"\";\n$value-chain-3: \"\";\n$value-chain-4: \"\";\n\n.material-symbols-outlined {\n\n    cursor: pointer;\n    font-variation-settings:\n        'FILL' 0,\n        'wght' 400,\n        'GRAD' 0,\n        'opsz' 48;\n}\n\np {\n    font-family:Arial, Helvetica, sans-serif;\n    text-align: justify;\n    color: $theme-back;\n}\n\n\n\nhtml, body { height: 100%; }\nbody { margin: 0; font-family: Roboto, \"Helvetica Neue\", sans-serif; }\n\n\n.generic-button, .generic-button-alt {\n  color: white;\n  border-radius: 5px;   /* Rounded corners */\n    padding: 10px 20px;    /* Padding for button size */\n    margin-right: 10px;\n\n    // font-size: 16px;       /* Font size */\n    cursor: pointer;       /* Pointer on hover */\n    transition: background-color 0.3s; /* Smooth transition on hover */\n\n    p {\n        color:white;\n        margin:0;\n    }\n}\n.generic-button {\n  background-color: $theme-main; /* Button background color */\n  border: 2px solid $theme-main;      /* No border */\n}\n\n.generic-button-alt {\n  background-color: $theme-accent; /* Button background color */\n  border: 2px solid $theme-accent;      /* No border */\n}\n\n.generic-button:hover {\n    background-color: #fff; /* Change color on hover */\n    color: $theme-main;\n\n    p {\n        color: $theme-main\n    }\n}\n\n.generic-button-alt:hover {\n  background-color: #fff; /* Change color on hover */\n  color: $theme-accent;\n\n  p {\n    color: $theme-accent\n  }\n}\n\n.generic-button:disabled, .generic-button-alt:disabled {\n    background-color: $theme-lightgray;\n    border-color: $theme-lightgray;\n    cursor:not-allowed;\n\n}\n","@font-face {\n  font-family: 'DM Sans';\n  font-style: normal;\n  font-weight: 900;\n  src: url('../assets/DM_Sans/static/DMSans-Black.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: normal;\n  font-weight: 800;\n  src: url('../assets/DM_Sans/static/DMSans-ExtraBold.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: normal;\n  font-weight: 700;\n  src: url('../assets/DM_Sans/static/DMSans-Bold.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: normal;\n  font-weight: 600;\n  src: url('../assets/DM_Sans/static/DMSans-SemiBold.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: normal;\n  font-weight: 500;\n  src: url('../assets/DM_Sans/static/DMSans-Medium.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: normal;\n  font-weight: 400;\n  src: url('../assets/DM_Sans/static/DMSans-Regular.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: normal;\n  font-weight: 300;\n  src: url('../assets/DM_Sans/static/DMSans-Light.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: normal;\n  font-weight: 200;\n  src: url('../assets/DM_Sans/static/DMSans-ExtraLight.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: normal;\n  font-weight: 100;\n  src: url('../assets/DM_Sans/static/DMSans-Thin.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: italic;\n  font-weight: 900;\n  src: url('../assets/DM_Sans/static/DMSans-BlackItalic.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: italic;\n  font-weight: 800;\n  src: url('../assets/DM_Sans/static/DMSans-ExtraBoldItalic.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: italic;\n  font-weight: 700;\n  src: url('../assets/DM_Sans/static/DMSans-BoldItalic.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: italic;\n  font-weight: 600;\n  src: url('../assets/DM_Sans/static/DMSans-SemiBoldItalic.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: italic;\n  font-weight: 500;\n  src: url('../assets/DM_Sans/static/DMSans-MediumItalic.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: italic;\n  font-weight: 400;\n  src: url('../assets/DM_Sans/static/DMSans-Italic.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: italic;\n  font-weight: 300;\n  src: url('../assets/DM_Sans/static/DMSans-LightItalic.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: italic;\n  font-weight: 200;\n  src: url('../assets/DM_Sans/static/DMSans-ExtraLightItalic.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: italic;\n  font-weight: 100;\n  src: url('../assets/DM_Sans/static/DMSans-ThinItalic.ttf');\n}\n\n","@import \"fonts\";\n\n// this file is more for variables that cannot be used in the theme\n// many of these should be migrated after the material theme has been configured.\n\n$font-family: \"Dm Sans\", sans-serif;\n\n/* Old palette\n$accent-btn: #DD7EB0;\n$dark-text: #303f71;\n$light-text: #fff;\n$inactive-text: #A3AED0;\n$accent-blue: #84D9FD;*/\n\n$accent-btn: #0CAD99;\n$dark-text: #1B3E78;\n$light-text: #fff;\n$inactive-text: #A3AED0;\n$accent-blue: #3792BF;\n\n$theme-main: #1B3E78;\n$theme-contrast: #0CAD99;\n$theme-1: #3792BF;\n$theme-2: #AACCFF;\n$theme-3: #BDBDBD;\n$theme-4: #7D7979;\n$theme-5: #787c95;\n\n$app-background: #F4F7FE;\n\n$rDNA-success: #00B300;\n$rDNA-alert: #FF0000;\n$rDNA-neutral: #FFBF00;\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
